import { motion } from 'framer-motion'
import logoImage from '../../Assets/fontbolt.png'
import './Loading.scss'

export default function SuspenseLoading() {
  return (
    <motion.div
      className="loading-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="loading-content">
        {/* Logo */}
        <motion.div
          className="loading-logo"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <img src={logoImage} alt="Medflix Logo" />
        </motion.div>

        {/* Loading Spinner */}
        <motion.div
          className="loading-spinner"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.4 }}
        >
          <div className="spinner-ring">
            <div className="ring"></div>
            <div className="ring"></div>
            <div className="ring"></div>
            <div className="ring"></div>
          </div>
        </motion.div>

        {/* Loading Progress Bar */}
        <div className="loading-progress-container">
          <div className="loading-progress-bar"></div>
        </div>
      </div>

      {/* Background Shapes */}
      <div className="loading-background">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
      </div>
    </motion.div>
  )
}
